"use client";

import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { isEmbedPath } from "@/lib/embed-routes";

const CookieBanner = dynamic(
  () =>
    import("@/components/analytics/cookie-banner").then((module) => ({
      default: module.CookieBanner,
    })),
  { ssr: false },
);

/**
 * One consent prompt/preferences control for every route group.
 *
 * Clerk-free on purpose: the root layout renders this on every surface,
 * including the marketing and token pages that ship no ClerkProvider. The
 * Account consent bridge (which needs Clerk's `useUser`) is mounted by
 * `ClerkScope` (components/auth/clerk-scope.tsx) in the Clerk-scoped route
 * groups instead.
 *
 * Not on `/embed/*`: those widgets are framed by other sites and load no
 * analytics or advertising tags, so there is nothing to consent to and the
 * banner only covered the widget (lib/embed-routes.ts).
 */
export function GlobalCookieControl() {
  const pathname = usePathname();
  if (isEmbedPath(pathname)) return null;
  return <CookieBanner />;
}
